import BannerHTML from "../pages/Banner/BannerHTML";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RequireAuthentication from "../auth/RequireAuthentication";
import { RoutePath } from "../constants/RoutePath";
import LayoutHTML from "../layouts/Layout/LayoutHTML";
import CategoryHTML from "../pages/Category/CategoryHTML";
import CustomerHTML from "../pages/Customer/CustomerHTML";
import DashboardHTML from "../pages/Dashboard/DashboardHTML";
import InventoryHTML from "../pages/Inventory/InventoryHTML";
import LoginHTML from "../pages/Login/LoginHTML";
import OrderHTML from "../pages/Order/OrderHTML";
import PermissionHTML from "../pages/Permission/PermissionHTML";
import UnitHTML from "../pages/Unit/UnitHTML";
import ProductHTML from "../pages/Product/ProductHTML";
import RoleHTML from "../pages/Role/RoleHTML";
import SaleHTML from "../pages/Sale/SaleHTML";
import UnauthorizedHTML from "../pages/Unauthorized/UnauthorizedHTML";
import UserHTML from "../pages/User/UserHTML";
import WarehouseHTML from "../pages/Warehouse/WarehouseHTML";
import TenantSetupHTML from "../pages/TenantSetup/TenantSetupHTML";
import TenantHTML from "../pages/Tenant/TenantHTML";
import IncomeHTML from "../pages/Income/IncomeHTML";
import ExpenseHTML from "../pages/Expense/ExpenseHTML";
import PermissionRoute from "../auth/PermissionRoute";
import RequireTenant from "../tenant/RequireTenant";
import RequireTenantSetup from "../tenant/RequireTenantSetup";
import RouteLifecycle from "./RouteLifecycle";
import InventoryMovementHTML from "../pages/InventoryMovement/InventoryMovementHTML";
import NotificationSettingHTML from "../pages/NotificationSetting/NotificationSettingHTML";
import NotificationLogHTML from "../pages/NotificationLog/NotificationLogHTML";
import SmtpSettingHTML from "../pages/SmtpSetting/SmtpSettingHTML";
import DailySalesSummaryHTML from "../pages/DailySalesSummary/DailySalesSummaryHTML";
import OrderHistoryHTML from "../pages/OrderHistory/OrderHistoryHTML";

import WarehouseGate from "../warehouse/WarehouseGate";
import InventoryTransferHTML from "../pages/InventoryTransfer/InventoryTransferHTML";
import SupplierHTML from "../pages/Supplier/SupplierHTML";
import PurchaseHTML from "../pages/Purchase/PurchaseHTML";
import InventoryCountHTML from "../pages/InventoryCount/InventoryCountHTML";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <RouteLifecycle />
      <Routes>
        <Route element={<RequireTenantSetup />}>
          <Route path={RoutePath.TenantSetup} element={<TenantSetupHTML />} />
        </Route>

        <Route element={<RequireTenant />}>
          <Route
            path="/"
            element={<Navigate to={RoutePath.Dashboard} replace />}
          />
          <Route path={RoutePath.Login} element={<LoginHTML />} />
          <Route path={RoutePath.Unauthorized} element={<UnauthorizedHTML />} />

          <Route element={<RequireAuthentication />}>
            <Route element={<LayoutHTML />}>
              <Route
                path={RoutePath.Dashboard}
                element={
                  <PermissionRoute
                    Permission="Dashboard.View"
                    Children={
                      <WarehouseGate>
                        <DashboardHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route path={RoutePath.Units} element={<PermissionRoute Permission="Unit.View" Children={<UnitHTML />} />} />
              <Route
                path={RoutePath.Products}
                element={
                  <PermissionRoute
                    Permission="Product.View"
                    Children={<ProductHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Categories}
                element={
                  <PermissionRoute
                    Permission="Category.View"
                    Children={<CategoryHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Customers}
                element={
                  <PermissionRoute
                    Permission="Customer.View"
                    Children={<CustomerHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Sales}
                element={
                  <PermissionRoute
                    Permission="Sale.View"
                    Children={
                      <WarehouseGate>
                        <SaleHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path={RoutePath.Income}
                element={
                  <PermissionRoute
                    Permission="Income.View"
                    Children={<IncomeHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Expenses}
                element={
                  <PermissionRoute
                    Permission="Expense.View"
                    Children={<ExpenseHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Orders}
                element={
                  <PermissionRoute
                    Permission="Order.View"
                    Children={
                      <WarehouseGate>
                        <OrderHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path={RoutePath.OrderHistory}
                element={
                  <PermissionRoute
                    Permission="Order.View"
                    Children={<OrderHistoryHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Suppliers}
                element={
                  <PermissionRoute
                    Permission="Supplier.View"
                    Children={<SupplierHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Purchases}
                element={
                  <PermissionRoute
                    Permission="Purchase.View"
                    Children={
                      <WarehouseGate>
                        <PurchaseHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path={RoutePath.InventoryCounts}
                element={
                  <PermissionRoute
                    Permission="Inventory.Manage"
                    Children={
                      <WarehouseGate>
                        <InventoryCountHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path="/inventory/stock-movements"
                element={<Navigate to={RoutePath.InventoryMovements} replace />}
              />
              <Route
                path={RoutePath.InventoryTransfers}
                element={
                  <PermissionRoute
                    Permission="Inventory.Manage"
                    Children={
                      <WarehouseGate>
                        <InventoryTransferHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path={RoutePath.Inventory}
                element={
                  <PermissionRoute
                    Permission="Inventory.View"
                    Children={
                      <WarehouseGate>
                        <InventoryHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path={RoutePath.InventoryMovements}
                element={
                  <PermissionRoute
                    Permission="Inventory.Manage"
                    Children={
                      <WarehouseGate>
                        <InventoryMovementHTML />
                      </WarehouseGate>
                    }
                  />
                }
              />
              <Route
                path={RoutePath.NotificationSettings}
                element={
                  <PermissionRoute
                    Permission="Notification.Manage"
                    Children={<NotificationSettingHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.NotificationLogs}
                element={
                  <PermissionRoute
                    Permission="Notification.View"
                    Children={<NotificationLogHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.SmtpSettings}
                element={
                  <PermissionRoute
                    Permission="Tenant.Manage"
                    Children={<SmtpSettingHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.DailySalesSummary}
                element={
                  <PermissionRoute
                    Permission="Report.View"
                    Children={<DailySalesSummaryHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Warehouses}
                element={
                  <PermissionRoute
                    Permission="Warehouse.View"
                    Children={<WarehouseHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Users}
                element={
                  <PermissionRoute
                    Permission="User.View"
                    Children={<UserHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Roles}
                element={
                  <PermissionRoute
                    Permission="Role.View"
                    Children={<RoleHTML />}
                  />
                }
              />
              <Route
                path={RoutePath.Permissions}
                element={
                  <PermissionRoute
                    Permission="Permission.View"
                    Children={<PermissionHTML />}
                  />
                }
              />
              <Route path={RoutePath.Banners} element={<PermissionRoute Permission="Tenant.Manage" Children={<BannerHTML />} />} />
              <Route
                path={RoutePath.Tenant}
                element={
                  <PermissionRoute
                    Permission="Tenant.Manage"
                    Children={<TenantHTML />}
                  />
                }
              />
            </Route>
          </Route>

          <Route
            path="*"
            element={<Navigate to={RoutePath.Dashboard} replace />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
